import React from 'react';
import SEO from '../components/SEO';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen">
      <SEO 
        title="Privacy Policy - Trademark Flare"
        description="Read Trademark Flare's privacy policy to understand how we collect, use, and protect your personal information when using our Canadian trademark registration services."
        keywords="privacy policy, data protection, trademark flare privacy, personal information security"
      />
      <section className="pt-24 pb-16 bg-gradient-to-br from-brand-600 to-brand-800">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-5xl font-bold text-white mb-4 text-center">
            Privacy Policy
          </h1>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg max-w-none">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Introduction</h2>
            <p className="text-gray-600 mb-6">
              Trademark Flare ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our trademark registration services and visit our website.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">Information We Collect</h2>
            <h3 className="text-2xl font-bold text-gray-900 mb-3 mt-6">Personal Information</h3>
            <p className="text-gray-600 mb-4">We collect personal information that you voluntarily provide to us when you:</p>
            <ul className="list-disc pl-6 text-gray-600 space-y-2 mb-6">
              <li>Register for our services</li>
              <li>Fill out contact forms or request information</li>
              <li>Communicate with us via email, phone, or chat</li>
              <li>Subscribe to our newsletter or updates</li>
            </ul>
            <p className="text-gray-600 mb-6">
              This information may include your name, email address, phone number, business details, and trademark information.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-3 mt-6">Automatically Collected Information</h3>
            <p className="text-gray-600 mb-6">
              When you visit our website, we may automatically collect certain information about your device, including information about your web browser, IP address, time zone, and cookies installed on your device.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">How We Use Your Information</h2>
            <p className="text-gray-600 mb-4">We use the information we collect to:</p>
            <ul className="list-disc pl-6 text-gray-600 space-y-2 mb-6">
              <li>Process your trademark registration applications with CIPO</li>
              <li>Communicate with you about your services and applications</li>
              <li>Respond to your inquiries and provide customer support</li>
              <li>Send you administrative information and updates</li>
              <li>Improve our services and website functionality</li>
              <li>Comply with legal obligations and protect our rights</li>
            </ul>

            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">Information Sharing</h2>
            <p className="text-gray-600 mb-6">
              We do not sell, trade, or rent your personal information to third parties. We may share your information with:
            </p>
            <ul className="list-disc pl-6 text-gray-600 space-y-2 mb-6">
              <li>The Canadian Intellectual Property Office (CIPO) as required for trademark registration</li>
              <li>Service providers who assist us in operating our business</li>
              <li>Legal and regulatory authorities when required by law</li>
              <li>Professional advisors such as lawyers and accountants</li>
            </ul>

            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">Data Security</h2>
            <p className="text-gray-600 mb-6">
              We implement appropriate technical and organizational security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet or electronic storage is 100% secure.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">Your Privacy Rights</h2>
            <p className="text-gray-600 mb-4">Under Canadian privacy laws, you have the right to:</p>
            <ul className="list-disc pl-6 text-gray-600 space-y-2 mb-6">
              <li>Access your personal information</li>
              <li>Request correction of inaccurate information</li>
              <li>Request deletion of your information (subject to legal obligations)</li>
              <li>Withdraw consent for certain uses of your information</li>
              <li>File a complaint with the Privacy Commissioner of Canada</li>
            </ul>

            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">Cookies and Tracking</h2>
            <p className="text-gray-600 mb-6">
              Our website uses cookies to enhance your experience. You can set your browser to refuse cookies or alert you when cookies are being sent. However, some parts of our website may not function properly without cookies.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">Changes to This Policy</h2>
            <p className="text-gray-600 mb-6">
              We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">Contact Us</h2>
            <p className="text-gray-600 mb-4">
              If you have questions about this Privacy Policy or our privacy practices, please contact us:
            </p>
            <div className="bg-brand-50 rounded-lg p-6 mb-6">
              <p className="text-gray-700"><strong>Email:</strong> <a href="mailto:info@trademarkflare.com">info@trademarkflare.com</a></p>
              <p className="text-gray-700"><strong>Phone:</strong> <a href="tel:+18669788034">+1 (866) 978-8034</a></p>
              <p className="text-gray-700"><strong>Address:</strong> 6156 Quinpool Rd, Halifax, NS B3L 1A3, Canada</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
